import { AbstractLogin } from "./abstract-login"

export class GoogleLogin extends AbstractLogin {
    public async login() {
        const googleProviderAuth = new this.auth.GoogleAuthProvider()
        const userCrendetials = await this.auth().signInWithPopup(googleProviderAuth)
        return this.loginWithFirebase(userCrendetials)
    }
}
